import { ref, computed } from "vue";
import { SyainService } from "@/service/SyainService";

/*
 * 備考（雇用契約）の更新
 */
export function useKoyouKeiyakuNotesUpdate() {
  let loading = ref(0)
  let isError = ref(false)

  const syainSrv = new SyainService();
  // 備考（雇用契約）の更新（※雇用契約に対する備考欄が社員マスタにあるため社員サービス扱い）
  const updateKoyouKeiyakuNotes = async (userId: number, notes: string) => {
    loading.value++
    const res = await syainSrv.updateKoyouKeiyakuNotes(userId, notes)
    loading.value--
    return res
  };

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value);
  });

  return {
    updateKoyouKeiyakuNotes,
    isLoading
  }
}
